module.exports = __webpack_public_path__ + "img/p_全方位医疗@2x.3db2f27f.png";